import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modals from 'root/modals';
import Model_Feedback from 'root/model/feedback';
import View from 'view/base';
import View_Overview from 'view/feedback_sidebar/overview';
import View_Session from 'view/feedback_sidebar/session';
import View_Activity from 'view/feedback_sidebar/activity';
import View_Comments from 'view/feedback_sidebar/comments';
import View_Feedback_Video_Player from 'view/feedback_viewer/video_player';
import View_Dev_Tools from 'view/dev_tools';
import { toggleWatch } from 'service/feedback';

import jui from 'root/lib/jquery-ui.min';

export default View.extend({
    className: 'feedback-sidebar',

    feedback_id: 0,
    inbox_mode: false,
    layout: 'default', // default, fullscreen, sidebar
    hide_expand: false,

    screenshot_num: 0,

    pending_xhr: null,

    views: {
        overview: {},
        session: {},
        activity: {},
        comments: {},
        video_player: {},
        devtools: {},
    },

    events: {
        'click .nav-close'                : 'onClose',
        'click .nav-prev'                 : 'onNavPrev',
        'click .nav-next'                 : 'onNavNext',
        'click .layout-option-item'       : 'onLayoutChange',
        'click .tab-menu > a'             : 'onTabClick',
        'click a[href="#activity"]'       : 'onViewActivity',
        'click .thumbnail-screenshot'     : 'onViewScreenshot',
        'click .thumbnail-video'          : 'onViewVideo',
        'click .thumbnail-replay'         : 'onViewSessionRecording',
        'click .thumbnail-devtools'       : 'onViewDevtools',
        'click .screenshot-nav-prev'      : 'onViewPrevScreenshot',
        'click .screenshot-nav-next'      : 'onViewNextScreenshot',
        'click .screenshot-expanded .pin' : 'onClickPinComment',
        'dblclick .feedback-title'        : 'onEditTitle',
        'click .feedback-watch'           : 'onWatch',
        'click .feedback-share'           : 'onShare',
        'click .feedback-rename'          : 'onEditTitle',
        'click .feedback-move'            : 'onMove',
        'click .feedback-delete'          : 'onDelete'
    },

    dom_handlers: {
        onClose: function(e) {
            this.pauseMediaPlayer();
            this.remove();
        },

        onLayoutChange: function(e) {
            var layout = $(e.currentTarget).data('val');

            this.changeLayout(layout);
            Cache.app.addUserSetting('feedback_sidebar_view', layout, false);
            this.$el.find('.region-screenshot').css('bottom', 0);
        },

        // prev feedback
        onNavPrev: function(e) {
            this.pauseMediaPlayer();

            var index_current = Cache.feedback.indexOf(this.model);
            var index_prev = index_current - 1;

            var model = Cache.feedback.at(index_prev);

            if (model) {
                Modals.openFeedbackSidebar(model.id, this.layout);
            }
        },

        // next feedback
        onNavNext: function(e) {
            this.pauseMediaPlayer();

            var index_current = Cache.feedback.indexOf(this.model);
            var index_next = index_current + 1;

            var model = Cache.feedback.at(index_next);

            if (model) {
                Modals.openFeedbackSidebar(model.id, this.layout);
            }
        },

        onTabClick: function(e) {
            var menu_name = $(e.currentTarget).attr('href').replace('#', '');

            this.toggleTabMenu(menu_name);
        },

        onViewActivity: function(e) {
            if (this.views.activity instanceof View_Activity) {
                this.views.activity.load();
            }
        },

        onViewPrevScreenshot: function(e) {
            var total = this.$el.find('.layout-devtools .thumbnail').length;
            var current_position = this.$el.find('.layout-devtools .thumbnail.active').index();
            var new_position = 0;

            if (current_position === 0) {
                new_position = total - 1;
            } else {
                new_position = current_position - 1;
            }

            this.$el.find('.layout-devtools .thumbnail').eq(new_position).click();
        },

        onViewNextScreenshot: function(e) {
            var total = this.$el.find('.layout-devtools .thumbnail').length;
            var current_position = this.$el.find('.layout-devtools .thumbnail.active').index();
            var new_position = 0;

            if (current_position === total - 1) {
                new_position = 0;
            } else {
                new_position = current_position + 1;
            }

            this.$el.find('.layout-devtools .thumbnail').eq(new_position).click();
        },

        onViewScreenshot: function(e) {
            this.screenshot_num = $(e.currentTarget).index();
            this.openScreenshot();
        },

        onViewVideo: function(e) {
            this.$el.find('.region-video-player').show();

            // thumbnail active state
            this.$el.find('.thumbnail').removeClass('active');
            this.$el.find('.thumbnail-video').addClass('active');
        },

        onViewSessionRecording: function(e) {
            if (!this.hasSessionRecording()) {
                return;
            }

            Modals.openSessionRecording(this.model.get('session_recording_id'), 0);
        },

        onViewDevtools: function(e) {
            if (!(this.views.devtools instanceof View_Dev_Tools)) {
                this.views.devtools = new View_Dev_Tools({feedback_id: this.model.id, show_event: true});
                this.views.devtools.render().$el.appendTo(this.$el.find('.region-devtools'));
            }

            var container = this.$el.find('.layout-devtools');

            if (container.hasClass('active')) {
                container
                    .removeClass('active')
                    .css('height', ''); // reset draggable
            } else {
                container.addClass('active');
            }
        },

        onClickPinComment: function(e) {
            this.$el.find('.screenshot-expanded .pin').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.dispatcher.trigger('Sidebar::View::Comments', $(e.currentTarget).data('id'));
        },

        onEditTitle: function(e) {
            if (Cache.app.isClient()) {
                return;
            }

            if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
                Modals.renameDesign(this.model.id);
            } else {
                Modals.renameFeedback(this.model.id);
            }
        },

        onMove: function(e) {
            Modals.moveFeedback([this.model.id]);
        },

        onDelete: function(e) {
            Modals.deleteFeedback([this.model.id]);
        },

        onShare: function(e) {
            Modals.shareFeedback(this.model);
        },

        onWatch: function(e) {
            toggleWatch(this.model.id);
        },

        onDocumentKeydown: function(e) {
            var target = $(e.target);

            if (target.is('input, textarea, select')) {
                return;
            }

            if (target.prop('contenteditable') === 'true') {
                return;
            }

            switch (e.keyCode) {
                case 27: // esc
                    if (!this.inbox_mode) {
                        this.remove();
                    }

                    break;
                case 38: // up arrow
                    e.preventDefault(); // stop scrolling
                    this.$el.find('.nav-prev').click();
                    break;
                case 40: // down arrow
                    e.preventDefault(); // stop scrolling
                    this.$el.find('.nav-next').click();
                    break;
                case 37: // left arrow
                    if (this.layout === 'sidebar') {
                        return;
                    }

                    e.preventDefault(); // stop scrolling
                    this.$el.find('.screenshot-nav-prev').click();
                    break;
                case 39: // right arrow
                    if (this.layout === 'sidebar') {
                        return;
                    }

                    e.preventDefault(); // stop scrolling
                    this.$el.find('.screenshot-nav-next').click();
                    break;
            }
        },

        onDragConsoleStart: function(e, ui) {
            ui.helper.data('panel_height', this.$el.find('.layout-devtools').height());
            ui.helper.data('offset_top_start', ui.offset.top);
        },

        onDragConsolePanel: function(e, ui) {
            var movement_y = ui.offset.top - ui.helper.data('offset_top_start');
            var height = ui.helper.data('panel_height') + movement_y * -1;

            this.$el.find('.layout-devtools').height(height);
        }
    },

    event_handlers: {
        onFeedbackRemove: function(model) {
            if (model.id !== this.feedback_id) {
                return;
            }

            // when the model is removed and re-added in the board view
            if (model.get('is_injected')) {
                return;
            }

            this.remove();
        },

        onFeedbackWatch: function(model) {
            // feedback model is not loaded yet
            if (!this.model) {
                return;
            }

            var is_following = Cache.feedback_watch_list.findWhere({feedback_id: this.model.id, user_id: Cache.real_user_id}) ? true : false;

            this.$el.find('.feedback-watch').text(is_following ? 'Unfollow' : 'Follow');
        },

        onCommentAdd: function(comment) {
            if (!this.model || comment.get('feedback_id') !== this.feedback_id ) {
                return;
            }

            // empty video bookmark
            if (comment.get('video_time')) {
                this.$el.find('.tab-menu a[href="#comments"]').click();
            }

            this.$el.find('a[href="#comments"] .count').text(this.model.getTotalComments());
        },

        onCommentRemove: function(comment) {
            if (!this.model || comment.get('feedback_id') !== this.feedback_id) {
                return;
            }

            this.$el.find('a[href="#comments"] .count').text(this.model.getTotalComments());
        },

        onViewComments: function(model_id) {
            this.$el.find('.tab-menu a[href="#comments"]').click();

            if (model_id) {
                this.selectPinComment(model_id);
            }
        },

        onPreviewViewScreenshot: function(show, screenshot_num) {
            // not screenshot feedback
            if (!this.model.get('screenshot')) {
                return;
            }

            if (show) {
                if (this.layout !== 'sidebar') {
                    return;
                }

                if (typeof screenshot_num !== 'undefined') {
                    this.screenshot_num = screenshot_num;
                }

                // screenshot image
                var screenshot_model = Cache.feedback_screenshot.where({feedback_id: this.model.id})[this.screenshot_num];

                if (screenshot_model) {
                    this.$el.find('.layout-preview').addClass('open');
                    this.$el.find('.layout-preview img').attr('src', screenshot_model.get('url'));

                    var image = new Image();
                    image.onload = () => {
                        this.renderPinComments(image, this.$el.find('.layout-preview > div'), this.$el.find('.layout-preview img'));
                    };
                    image.src = screenshot_model.get('url');
                }
            } else {
                this.$el.find('.layout-preview').removeClass('open');
                this.$el.find('.layout-preview .pin').remove();
            }
        },

        onThreadSelect: function(view_cid, model_id) {
            if (!model_id) {
                // feedback description
                return;
            }

            this.selectPinComment(model_id);
        },

        onViewScreenshot: function(screenshot_num) {
            this.screenshot_num = screenshot_num;
            this.openScreenshot();
        },

        onExpanedScreenshot: function(screenshot_num) {
            var saved_expanded_layout = Cache.app.getUserSetting('feedback_sidebar_view', false);
            saved_expanded_layout = ['default', 'fullscreen'].indexOf(saved_expanded_layout) !== -1 ? saved_expanded_layout : 'default';

            if (this.inbox_mode) {
                Modals.openFeedbackSidebar(this.model.id, saved_expanded_layout);
            } else {
                if (typeof screenshot_num !== 'undefined') {
                    this.screenshot_num = screenshot_num;
                }

                this.changeLayout(saved_expanded_layout);
                Cache.app.addUserSetting('feedback_sidebar_view', saved_expanded_layout, false);

                this.$el.find('.layout-preview').removeClass('open');
            }
        },

        onBuildPage: function() {
            this.remove();
        }
    },

    initialize: function(options) {
        this.feedback_id  = options.feedback_id;
        this.inbox_mode   = !!options.inbox_mode;
        this.hide_expand  = !!options.hide_expand;
        this.dispatcher   = options.dispatcher || _.extend({}, Backbone.Events);

        if (this.inbox_mode) {
            // inbox must be in sidebar layout
            this.layout = 'sidebar';
        } else if (options.layout) {
            // use the enforced layout
            this.layout = options.layout;
        } else {
            // user setting
            this.layout = Cache.app.getUserSetting('feedback_sidebar_view', false);
        }

        // final validation because the saved user setting can be stale data
        if (['default', 'fullscreen', 'sidebar'].indexOf(this.layout) === -1) {
            this.layout = 'default';
        }

        if (UI.isMobile()) {
            this.layout = 'sidebar';
            this.hide_expand = true;
        }

        this.model = Cache.feedback.get(this.feedback_id);

        if (this.isLoaded()) {
            this.createViews();
        }

        this.listenTo(this.model, 'change:title', this.renderTitle);

        this.listenTo(Cache.feedback, 'remove', this.event_handlers.onFeedbackRemove.bind(this));

        this.listenTo(Cache.feedback_comment, 'add',    this.event_handlers.onCommentAdd);
        this.listenTo(Cache.feedback_comment, 'remove', this.event_handlers.onCommentRemove);

        this.listenTo(Cache.feedback_watch_list, 'add',    this.event_handlers.onFeedbackWatch.bind(this));
        this.listenTo(Cache.feedback_watch_list, 'remove', this.event_handlers.onFeedbackWatch.bind(this));
        this.listenTo(Cache.feedback_watch_list, 'reset',  this.event_handlers.onFeedbackWatch.bind(this));

        Cache.app.dispatcher.on('UI::build_page', this.event_handlers.onBuildPage.bind(this));

        this.dispatcher.on('Thread:Select',                     this.event_handlers.onThreadSelect.bind(this));
        this.dispatcher.on('Sidebar::Preview::Screenshot',      this.event_handlers.onPreviewViewScreenshot.bind(this));
        this.dispatcher.on('Sidebar::Expand::Screenshot',       this.event_handlers.onExpanedScreenshot.bind(this));
        this.dispatcher.on('Sidebar::View::Comments',           this.event_handlers.onViewComments.bind(this));
        this.dispatcher.on('Sidebar::View::Screenshot' ,        this.event_handlers.onViewScreenshot.bind(this));

        $(document).on('keydown.' + this.cid, this.dom_handlers.onDocumentKeydown.bind(this));

        this.on('remove', () => {
            $(document).off('keydown.' + this.cid);

            if (this.pending_xhr) {
                this.pending_xhr.abort();
            }
        });
    },

    createViews: function() {
        this.views.overview = new View_Overview({
            model: this.model,
            dispatcher: this.dispatcher,
            inbox_mode: this.inbox_mode
        });
        this.views.session = new View_Session({
            model: this.model,
            dispatcher: this.dispatcher
        });

        if (!this.inbox_mode) {
            this.views.comments = new View_Comments({
                model: this.model,
                dispatcher: this.dispatcher
            });
        }

        if (this.hasActivity()) {
            this.views.activity = new View_Activity({model: this.model});
        }

        if (this.model.get('video_url')) {
            this.views.video_player = new View_Feedback_Video_Player({
                model: this.model
            });
        }
    },

    loadFeedback: function() {
        this.pending_xhr = Cache.app.request({
            action: 'feedback/loadAll',
            data: {
                id: this.feedback_id
            },
            success: (response) => {
                if (response.feedback.length) {
                    // when model is not defined, it means the model is not in the search list
                    // but it's loaded from url parameters or from other views via passing feedback_id
                    if (!this.model) {
                        // do not add model to the Cache.feedback
                        // because once it's added it will appear in the search list
                        this.model = new Model_Feedback(response.feedback[0]);
                    }

                    if (this.model.isExpired()) {
                        this.remove();
                        this.trigger('feedback:expired');
                    } else {
                        Cache.feedback_comment.add(response.feedback_comment);
                        Cache.feedback_screenshot.add(response.feedback_screenshot);

                        this.setUnsubscribedEmails(response.unsubscribed_emails);

                        // custom property (not model attribute) because we don't want to save it
                        this.model.is_sidebar_loaded = true;

                        this.createViews();

                        // no slide-in animation when re-render from loading state
                        this.render();
                    }
                } else {
                    UI.error('Feedback couldn\'t be loaded.');
                }
            },
            complete: () => {
                this.pending_xhr = null;
            },
            error: () => {
                // leave empty for no error ui when the xhr.abort() is called
            }
        });
    },

    getScreenshotModels: function() {
        return Cache.feedback_screenshot.where({feedback_id: this.model.id});
    },

    pauseVideoPlayer: function() {
        if (this.views.video_player instanceof View_Feedback_Video_Player) {
            this.views.video_player.pause();
        }
    },

    pauseMediaPlayer: function() {
        this.pauseVideoPlayer();
    },

    setUnsubscribedEmails: function (emails) {
        var feedback_id = this.model.id;

        var unsubscribed_emails = Cache.get('feedback_unsubscribed_emails') || {};

        if (!unsubscribed_emails[feedback_id]) {
            unsubscribed_emails[feedback_id] = [];
        }

        emails.forEach((email) => {
            var exists = unsubscribed_emails[feedback_id].includes(email);

            if (!exists) {
                unsubscribed_emails[feedback_id].push(email);
            }
        });

        Cache.add('feedback_unsubscribed_emails', unsubscribed_emails, false);
    },

    hasActivity: function() {
        return Cache.real_user_id && !Cache.app.isClient();
    },

    hasSessionRecording: function() {
        if (Cache.real_user_id && !Cache.app.isClient() && this.model.get('session_recording_id')) {
            return true;
        }

        return false;
    },

    renderPinComments: function(image, container, image_element) {
        var img_width  = image_element.width();
        var img_height = image_element.height();
        var zoom       = img_width / image.width;

        container.find('.pin').remove();

        // pin comments
        Cache.feedback_comment.where({
            feedback_id      : this.model.id,
            reply_comment_id : 0,
            screenshot_num   : this.screenshot_num
        }).forEach((model) => {
            if (model.get('screen_number') > 0) {
                $('<div>')
                .addClass('pin')
                .data('id', model.id)
                .text(model.get('screen_number'))
                .css({
                    top  : (model.get('screen_y') * zoom) / img_height * 100 + '%',
                    left : (model.get('screen_x') * zoom) / img_width * 100 + '%'
                })
                .appendTo(container);
            };
        });
    },

    // highlight pin comment in screenshot preview
    selectPinComment: function(model_id) {
        this.$el.find('.layout-preview .pin').each((index, element) => {
            $(element).toggleClass('selected', $(element).data('id') === model_id);
        });

        this.$el.find('.screenshot-expanded .pin').each((index, element) => {
            $(element).toggleClass('selected', $(element).data('id') === model_id);
        });
    },

    openScreenshot: function() {
        var screenshot_models = this.getScreenshotModels();

        if (!screenshot_models.length) {
            return;
        }

        // toogle screenshot / session replay
        this.$el.find('.region-screenshot').show();

        // thumbnail active state
        this.$el.find('.thumbnail').removeClass('active');
        this.$el.find('.thumbnail-screenshot').eq(this.screenshot_num).addClass('active');

        var screenshot_model = screenshot_models[this.screenshot_num];

        // screenshot preview
        this.$el.find('.screenshot-expanded img').attr('src', screenshot_model.get('url'));

        // pin comments
        this.$el.find('.screenshot-expanded .pin').remove();

        var image = new Image();
        image.onload = () => {
            this.renderPinComments(image, this.$el.find('.region-screenshot .screenshot-expanded'), this.$el.find('.screenshot-expanded img'));
        };
        image.src = screenshot_model.get('url');
    },

    toggleNavButtons: function() {
        var index_current = Cache.feedback.indexOf(this.model);
        var index_next = index_current + 1;

        this.$el.find('.nav-prev').prop('disabled', index_current === 0);
        this.$el.find('.nav-next').prop('disabled', Cache.feedback.at(index_next) ? false : true);
    },

    isLoaded: function() {
        if (!this.model) {
            return false;
        }

        if (this.model.is_sidebar_loaded) {
            return true;
        }

        if (this.model.get('screenshot') && !Cache.feedback_screenshot.findWhere({feedback_id: this.model.id})) {
            return false;
        }

        var unsubscribed_emails = Cache.get('feedback_unsubscribed_emails');

        if (!unsubscribed_emails || !unsubscribed_emails[this.model.id]) {
            return false;
        }

        if (!Cache.feedback_comment.findWhere({feedback_id: this.model.id})) {
            return false;
        }

        return true;
    },

    getTabs: function() {
        var html =
        '<div class="tab">' +
            '<div class="tab-menu margin-bottom-0">' +
                '<a href="#overview">Details</a>' +
                (this.inbox_mode ? '' :
                '<a href="#comments">' +
                    '<span class="flex-c">' +
                        '<span>Comments</span>' +
                        (this.isLoaded() ?
                        '<span class="count badge-secondary-invert badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.model.getTotalComments() + '</span>' : '') +
                    '</span>' +
                '</a>') +
                (this.hasActivity() ?
                '<a href="#activity">Activity</a>' : '') +
            '</div>' +
        '</div>';

        return html;
    },

    toggleTabMenu: function(menu_name) {
        this.$el.find('.region-tab-content').removeClass('active');
        this.$el.find('.region-' + menu_name).addClass('active');

        if (menu_name === 'overview') {
            // update pin comment position when the tab becomes visible
            if (this.views.overview instanceof View_Overview) {
                this.views.overview.renderPinComments();
            }
        }
    },

    getLayoutIcon: function(layout) {
        switch (layout) {
            case 'default':
                return '' +
                '<span class="layout-icon fa-stack">' +
                    '<i class="fa-regular fa-expand fa-stack-2x"></i>' +
                    '<i class="fa-solid fa-arrow-down-left-and-arrow-up-right-to-center fa-stack-1x"></i>' +
                '</span>';
            case 'fullscreen':
                return '' +
                '<span class="layout-icon fa-stack">' +
                    '<i class="fa-regular fa-expand-wide fa-stack-2x"></i>' +
                    '<i class="fa-solid fa-arrow-up-right-and-arrow-down-left-from-center fa-stack-1x"></i>' +
                '</span>';
            case 'sidebar':
                return '' +
                '<span class="layout-icon fa-stack">' +
                    '<i class="fa-solid fa-right-to-line fa-stack-2x"></i>' +
                '</span>';
            default:
                return '';
        }

    },

    changeLayout: function(layout) {
        this.layout = layout;

        this.$el.find('.layout-option-item').removeClass('active');
        this.$el.find('.layout-option-item[data-val="' + layout + '"]').addClass('active');

        this.$el.find('.nav-layout').html(this.getLayoutIcon(layout));

        if (layout === 'sidebar') {
            this.pauseMediaPlayer();

            // update pin comment position when the tab becomes visible
            if (this.views.overview instanceof View_Overview) {
                this.views.overview.renderPinComments();
            }
        } else {
            this.openScreenshot();
        }

        this.$el.attr('data-layout', layout);
    },

    renderTitle: function() {
        this.$el.find('.feedback-title').text(this.model.get('title'));
    },

    render: function() {
        this.$el.toggleClass('feedback-sidebar-inbox', this.inbox_mode);
        this.$el.attr('data-layout', this.layout);

        if (!this.isLoaded()) {
            var content =
            '<div class="layout-main loader"></div>' +
            '<div class="layout-sidebar">' +
                '<div class="layout-sidebar-header">' +
                    (this.inbox_mode ? '' :
                    '<div class="region-nav">' +
                        '<button type="button" class="nav-close"><i class="fa-regular fa-xmark"></i></button>' +
                    '</div>' +
                    '<div class="region-heading">' +
                        '<div class="badge-id">' + this.feedback_id  + '</div>' +
                        '<div class="feedback-title">' +
                            '<div class="loader-placeholder" style="width:50%;"></div>' +
                        '</div>' +
                    '</div>') +
                    '<div class="region-tabs">' +
                        this.getTabs() +
                    '</div>' +
                    '<div class="loader-placeholder margin-bottom-12"></div>' +
                    '<div class="loader-placeholder margin-bottom-12"></div>' +
                    '<div class="loader-placeholder" style="width:70%;"></div>' +
                '</div>' +
            '</div>';

            this.$el.html(content);
            this.loadFeedback();
            return this;
        }

        var screenshot_thumbnails = '';
        var screenshot_models = this.getScreenshotModels();

        screenshot_models.forEach((model, index) => {
            screenshot_thumbnails += '<div class="thumbnail thumbnail-screenshot' + (index === this.screenshot_num ? ' active' : '') + '" style="background-image:url(\'' + model.get('url') + '\');"></div>';
        });

        var is_following = Cache.feedback_watch_list.findWhere({feedback_id: this.model.id, user_id: Cache.real_user_id}) ? true : false;

        var content =
        '<div class="layout-main">' +
            (screenshot_models.length > 1 || screenshot_models.length === 1 && this.hasSessionRecording() ?
            '<button type="button" class="screenshot-nav-prev"><i class="fa-solid fa-chevron-left"></i></button>' +
            '<button type="button" class="screenshot-nav-next"><i class="fa-solid fa-chevron-right"></i></button>' : '') +

            '<div class="layout-screenshot">' +
                '<div class="region-screenshot">' +
                    (this.model.get('video_url') ? '' :
                    (screenshot_models.length ?
                    '<div class="screenshot-expanded"><img src="' + screenshot_models[this.screenshot_num].get('url') + '"></div>' :
                    '<div class="screenshot-empty"></div>')) +
                '</div>' +

                (this.model.get('video_url') ?
                '<div class="region-video-player"></div>' : '') +
            '</div>' +
            '<div class="layout-devtools">' +
                '<span class="drag-handle"></span>' +

                '<div class="region-thumbnails">' +
                    // screenshot thumbnails
                    screenshot_thumbnails +
                    (screenshot_thumbnails.length > 0 ?
                    '<div class="thumbnail-divider"></div>' : '') +

                    // video thumbnail
                    (this.model.get('video_url') ?
                    '<div class="thumbnail thumbnail-video active">' +
                        '<video preload="auto" src="' + this.model.escape('video_url') + '"></video>' +
                    '</div><div class="thumbnail-divider"></div>' : '') +


                    (this.hasSessionRecording() ?
                    '<div class="thumbnail thumbnail-replay"><i class="fa-solid fa-circle-play"></i>Replay</div>' :
                    '<div class="thumbnail thumbnail-replay thumbnail-disabled tooltip" data-title="No session replay captured"><i class="fa-solid fa-circle-play"></i>Replay</div>') +
                    '<div class="thumbnail thumbnail-devtools"><i class="fa-solid fa-code"></i>Dev Tools</div>' +
                '</div>' +
                '<div class="region-devtools"></div>' +
            '</div>' +
        '</div>' +
        '<div class="layout-preview"><div><img></div></div>' +
        '<div class="layout-sidebar">' +
            '<div class="layout-sidebar-header">' +
                (this.inbox_mode ? '' :
                '<div class="region-nav">' +
                    (Cache.app.isClient() ? '' :
                    '<div class="button-dropdown sidebar-actions">' +
                        '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                        '<div>' +
                            '<ul class="dropdown">' +
                                '<li class="feedback-watch">' + (is_following ? 'Unfollow' : 'Follow') + '</li>' +
                                '<li class="feedback-share">Share</li>' +
                                '<li class="feedback-rename">Edit Title</li>' +
                                (this.model.isMergedFeedback() ? '' :
                                '<li class="feedback-move">Move</li>') +
                                '<li class="separator"></li>' +
                                '<li class="feedback-delete">Delete</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>') +

                    (this.hide_expand ? '' :
                    '<div class="button-dropdown button-dropdown-xlarge" data-append="true" data-offset="60,0">' +
                        '<button type="button" class="nav-layout tooltip" data-title="Switch Layout" data-position="down" data-offset="0,-10">' + this.getLayoutIcon(this.layout) + '</button>' +
                        '<div class="layout-options">' +
                            '<div>' +
                                '<span class="layout-option-item" data-val="default"' + (this.layout === 'default' ? ' class="active"' : '') + '>' +
                                    this.getLayoutIcon('default') +
                                    '<div>Default</div>' +
                                '</span>' +
                                '<span class="layout-option-item" data-val="fullscreen"' + (this.layout === 'fullscreen' ? ' class="active"' : '') + '>' +
                                    this.getLayoutIcon('fullscreen') +
                                    '<div>Full screen</div>' +
                                '</span>' +
                                '<span class="layout-option-item" data-val="sidebar"' + (this.layout === 'sidebar' ? ' class="active"' : '') + '>' +
                                    this.getLayoutIcon('sidebar') +
                                    '<div>Sidebar</div>' +
                                '</span>' +
                            '</div>' +
                        '</div>' +
                    '</div>') +

                    '<button type="button" class="nav-prev"><i class="fa-regular fa-angle-up"></i></button>' +
                    '<button type="button" class="nav-next"><i class="fa-regular fa-angle-down"></i></button>' +
                    '<button type="button" class="nav-close"><i class="fa-regular fa-xmark"></i></button>' +
                '</div>' +
                '<div class="region-heading">' +
                    '<div class="flex-start">' +
                        '<div class="badge-id">' + this.feedback_id  + '</div>' +
                        (this.model.get('sentiment') ?
                        '<div class="feedback-sentiment tooltip" data-title="User sentiment: ' + this.model.getSentimentText() + '">' + this.model.getSentimentIcon() + '</div>' : '') +
                    '</div>' +
                    '<div class="feedback-title">' + this.model.escape('title') + '</div>' +
                '</div>') +
                '<div class="region-tabs">' +
                    this.getTabs() +
                '</div>' +
            '</div>' +
            '<div class="layout-sidebar-body">' +
                '<div class="region-tab-content region-overview"></div>' +
                (this.hasActivity() ?
                '<div class="region-tab-content region-activity"></div>' : '') +
                '<div class="region-tab-content region-comments"></div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.views.overview.render().$el.appendTo(this.$el.find('.region-overview'));
        this.views.session.render().$el.appendTo(this.$el.find('.region-overview'));

        if (!this.inbox_mode) {
            this.views.comments.render().$el.appendTo(this.$el.find('.region-comments'));
        }

        if (this.hasActivity()) {
            this.views.activity.render().$el.appendTo(this.$el.find('.region-activity'));
        }

        if (this.model.get('video_url')) {
            this.views.video_player.render().$el.appendTo(this.$el.find('.region-video-player'));
        }

        if (this.layout !== 'sidebar' && screenshot_models.length) {
            // set default to screenshot
            this.openScreenshot();
        }

        this.toggleNavButtons();

        // default tab
        var tab_menu = this.$el.find('.tab-menu a:first');
        var menu_name = tab_menu.attr('href').replace('#', '');

        tab_menu.addClass('active');
        this.toggleTabMenu(menu_name);

        this.$el.find('.drag-handle').draggable({
            axis: 'y',
            helper: 'clone',
            start: this.dom_handlers.onDragConsoleStart.bind(this),
            drag: this.dom_handlers.onDragConsolePanel.bind(this)
        });

        return this;
    }
});
